import React from 'react';
import { Card, Space } from '@douyinfe/semi-ui';

class DenyLoginWithStatusAndRole extends React.Component {
    constructor(props) {
        super(props);
    };

    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Space vertical align="center">
                    <Card
                        title={<h3 style={{ textAlign: 'center', width: '100%' }}>Доступ запрещен</h3>}
                        style={{ textAlign: 'center', maxWidth: 400 }}
                        bodyStyle={{ padding: 16 }}
                        bordered
                    >
                        <span className='deniedSpan'>{this.props.text}</span>
                    </Card>
                </Space>
            </div>
        );
	}

}

export default DenyLoginWithStatusAndRole;